import BuyNowPayLaterContent from 'components/GlobalModals/BuyNowPayLaterModal/BuyNowPayLaterContent/BuyNowPayLaterContent';

export default BuyNowPayLaterContent;
